/*INCLUDE OWL CAROUSEL*/
require('owl.carousel');
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css');
import {IsScrolledIntoView} from '../includes/utils'

let owlConfig = {}


owlConfig.na = {
    items: 1,
    loop: true,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    baseClass : "owl-carousel",
    theme : "owl-theme",
    nav : true,
    navText : ['<div class="nav-btn"><i class="ai ai-left-arrow"></i></div>', '<div class="nav-btn"><i class="ai ai-right-arrow"></i></div>'],
    dots: false,
    slideBy: 1,
    startPosition: 0,
    onInitialized: function(event){
        let $this = $(event.target);
        $this.find('.owl-stage-outer').before($this.parent().find('.slider-onInitialized').html());
    },
    responsive:{
        0:{
            stagePadding: 50,
            nav : false,
        },
        768:{
            stagePadding: 150,
        },
        992:{
            stagePadding: 180,
        },
    }
}



owlConfig.circle = {
    autoplay:true,
    autoplayTimeout: 5000,
    center: true,
    loop: false,
    items: 3,
    nav: false,
    navText: ['<i class="ai ai-left-arrow"></i>','<i class="ai ai-right-arrow"></i>'],
    theme : "owl-theme",
    stageOuterClass: 'owl-stage-outer',
    responsive:{
        0:{
            items: 1,
            nav: true,
        },
        960:{
            items: 3,
        },
    },
    onInitialized: function(event){

        let $this = $(event.target);
        $this.find('.owl-stage-outer').before($this.parent().find('.slider-onInitialized').html());

        // let onInitializedElement = $('.slider-onInitialized').html();
        // $('.slider-circle.owl-carousel .owl-stage-outer').after(onInitializedElement);
        $this.find('.slider-item').each( function( index ) {
            $(this).attr( 'data-position', index ); // NB: .attr() instead of .data()
            $(this).on('click', function() {
                $(this).closest('.owl-carousel').trigger('to.owl.carousel', $(this).data( 'position' ) );
            });
        });
    },
    onChanged: function(event){
      /* Quand on arrive dernier slide on se remet au premier après quelques secondes */
      let lastPosition = event.item.count - 1;
      if (event.item.index === lastPosition) {
        setTimeout(function(){
          $(event.target).trigger('to.owl.carousel', 0);
        }, 7000)
      }
    },
};

owlConfig.single1 = {
    loop: true,
    autoplay: true,
    items: 1,
    nav: true,
    navText: ['<i class="ai ai-left-arrow"></i>','<i class="ai ai-right-arrow"></i>'],
    theme : "owl-theme",
    stageOuterClass: 'owl-stage-outer',
    onInitialized: function(event){

    },
};

owlConfig.single2 = {
    loop: false,
    items: 1,
    nav: false,
    dots: true,
    theme : "owl-theme",
};


owlConfig.singleWithDots = {
    // autoWidth:true,
    loop: true,
    nav: true,
    items:1,
    dots: true,
    navText: ['<i class="ai ai-left-arrow"></i>','<i class="ai ai-right-arrow"></i>'],
    theme : "owl-theme",
    onInitialized: function(event){
        let $this = $(event.target);
        // $this.find('.owl-dots').append($this.find('.owl-nav'));
        $this.find('.owl-nav').before('<div class="wrap-nav-and-dots"></div>');
        $this.find('.wrap-nav-and-dots').append( $this.find(".owl-nav"));
        $this.find('.wrap-nav-and-dots').append( $this.find(".owl-dots"));
    },
};


$('.owl-carousel').each(function () {

    let $obj = $(this)
    let owl = null

    let confName = $(this).data('config');
    if(confName && owlConfig[confName]) {
        owl = $(this).owlCarousel(owlConfig[confName]);
        $(window).scroll(function(){
            if(IsScrolledIntoView($obj)) {
                owl.trigger('play.owl.autoplay',[5000])
            }
            // else {
            //     owl.trigger('stop.owl.autoplay')
            // }
        });
    }


})



// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/owl-carousel.js